
const Footer = () => {
  return (
    <footer className="bg-[#4A4A48] text-white py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col items-center text-center space-y-8">
          <img 
            src="https://static.readdy.ai/image/721199a06948bc0907bde1e591c4b4e9/c94c06ec866ae013d36a27b4196bcf20.png"
            alt="2b LLC"
            className="h-10 object-contain opacity-90"
          />
          
          <div className="space-y-2 text-sm">
            <p>東京都世田谷区</p>
            <p>
              <a 
                href="mailto:tobe26.2b@gmail.com" 
                className="hover:text-[#AFC5C2] transition-colors duration-300"
              >
                tobe26.2b@gmail.com
              </a>
            </p>
            <p>
              <a 
                href="https://note.com/2b_ai" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-white/70 hover:text-[#AFC5C2] transition-colors duration-300"
              >
                思考の記録
              </a>
            </p>
          </div>
          
          <div className="border-t border-white/20 pt-6 w-full">
            <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-4 text-sm">
              <p>© 2025 2b LLC</p>
              <span className="hidden md:inline text-white/40">|</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-white/60 hover:text-[#AFC5C2] transition-colors duration-300"
                rel="nofollow"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
